module.exports = "<section class=\"container-fluid with-maxwidth chapter\">\r\n\t <my-cliente-consultar></my-cliente-consultar>\r\n</section>"


//////////////////
// WEBPACK FOOTER
// ./src/app/cliente/cliente.component.html
// module id = ./src/app/cliente/cliente.component.html
// module chunks = main